import React from 'react';
import BuilderSelectMenu from '../BuilderSelectMenu';
import { IStyled } from '../../../styles/types';
import { ITooltipOption } from '../../KubitTooltip/globalTooltips';

interface IProps<Option, Key> extends IStyled {
  label?: string;
  enumOptions: Option[];
  selectedOption: Key;
  onChange: (newSelectedOption: Key) => void;
  tooltipOption?: ITooltipOption;
  disabled?: boolean;
  labelIsInSentence?: boolean;
  maxMenuHeight?: number;
}

type OptionShape<Key> = {
  name: string;
  key: Key;
  tooltip?: ITooltipOption;
  disabled?: boolean;
};
type KeyShape = string;

export default <Key extends KeyShape, Option extends OptionShape<Key>>({
  label,
  labelIsInSentence,
  enumOptions,
  selectedOption,
  onChange,
  className,
  tooltipOption,
  disabled,
  maxMenuHeight,
}: IProps<Option, Key>) => {
  const menuOptions =
    enumOptions.map(({ name, key, tooltip, disabled }) => ({
      text: name,
      value: key,
      tooltip,
      disabled,
    })) ?? [];

  const handleOnChange = (newSelection: string) => {
    onChange(newSelection as Key);
  };

  return (
    <BuilderSelectMenu
      className={className}
      label={label}
      options={menuOptions}
      value={selectedOption}
      onChange={handleOnChange}
      disabled={disabled || enumOptions.length === 1}
      tooltipOption={tooltipOption}
      hideCaret={labelIsInSentence}
      maxMenuHeight={maxMenuHeight}
    />
  );
};
